module.exports = ".heading__description {\n    margin-bottom: 30px;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/organization/components/approvals/transacion-aprovals/transacion-aprovals.component.css
// module id = ./src/app/organization/components/approvals/transacion-aprovals/transacion-aprovals.component.css
// module chunks = main